import React from "react";
import { Field, change } from "redux-form";
import Step from "../Step";

import styles from "../styles.module.css";
import stylesButton from "../../utils/css/button.module.css";
import WithUserForm from "../../Register/WithUserForm";
import withHooks from "react-with-hooks";

const fashionIconSkills = [
  "fashion model",
  "digital creator",
  "influencer",
  "ambassador",
  "photographer",
  "performer",
  "hair/mua",
  "editor/stylist"
];

const brandSkills = [
  "clothing",
  "swim/beach",
  "accessories",
  "jewellery",
  "beauty/skin",
  "other"
];
const widthMap = {
  "fashion model": "49.5%",
  "digital creator": "49.5%",
  "influencer": "45.8%",
  "ambassador": "53.2%",
  "photographer": "55.8%",
  "performer": "43.2%",
  "hair/mua": "42.6%",
  "editor/stylist": "56.4%",

  "clothing": "41.5%",
  "swim/beach": "57.5%",
  "accessories": "54%",
  "jewellery": "45%",
  "beauty/skin": "64%",
  "other": "35%",
};
const SelectedSkills = withHooks((props) => {

  return (
    <div className={styles.skills_categories}>
      {/* Fashion Icon Category */}
      <div className='w-full'>
        <div
          className={`${styles.category_header} ${props.isFashionIconSelected ? styles.category_header_selected : ''}`}
          onClick={() => props.toggleCategory('fashionIcon')}
        >
          <span className={`${styles.category_checkbox} ${props.isFashionIconSelected && styles.category_checkbox_selected}`}>
            {props.isFashionIconSelected ? "✓" : ""}
          </span>
          I am a Fashion Icon
        </div>
        <div className={styles.skill_buttons_grid}>
          {fashionIconSkills.map((skill, index) => {
            const isSelected = props.checkedSkills.includes(skill);
            return (
              <button
                key={skill}
                type="button"
                disabled={!props.isFashionIconSelected}
                className={`${styles.skill_button} ${!props.isFashionIconSelected && styles.skill_button_disabled} ${isSelected && styles.skill_button_selected}`}
                onClick={() => props.handleCheckedSkills(skill)}
                style={{ width: widthMap[skill] }}
              >
                {isSelected ? 'x' : '+'} {skill}
              </button>
            );
          })}
        </div>
      </div>

      {/* Brand Category */}
      <div className='w-full'>
        <div
            className={`${styles.category_header} ${props.isBrandSelected ? styles.category_header_selected : ''}`}
            onClick={() => props.toggleCategory('brand')}
        >
          <span className={`${styles.category_checkbox} ${props.isBrandSelected && styles.category_checkbox_selected}`}>
            {props.isBrandSelected ? "✓" : ""}
          </span>
          I am a Brand
        </div>
        <div className={styles.skill_buttons_grid}>
          {brandSkills.map((skill) => {
            const isSelected = props.checkedSkills.includes(skill);
            return (
              <button
                key={skill}
                type="button"
                disabled={!props.isBrandSelected}
                className={`${styles.skill_button} ${!props.isBrandSelected && styles.skill_button_disabled} ${isSelected && styles.skill_button_selected}`}
                onClick={() => props.handleCheckedSkills(skill)}
                style={{ width: widthMap[skill] }}
              >
                {isSelected ? 'x' : '+'} {skill}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
});

export default class StepSkills extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedSkills: [],
      isError: false,
      isFashionIconSelected: false,
      isBrandSelected: false,
    };
  }


  toggleCategory = (category) => {
    if (category === 'fashionIcon') {
      const newState = !this.state.isFashionIconSelected;
      this.setState({
        isFashionIconSelected: newState,
        isBrandSelected: false,
        checkedSkills: []
      });
    } else if (category === 'brand') {
      const newState = !this.state.isBrandSelected;
      this.setState({
        isBrandSelected: newState,
        isFashionIconSelected: false,
        checkedSkills: []
      });
    }
  };

  handleCheckedSkills = (skill) => {
    const checkedSkills = [...this.state.checkedSkills];
    if (checkedSkills.includes(skill)) {
      const index = checkedSkills.indexOf(skill);
      checkedSkills.splice(index, 1);
    } else {
      checkedSkills.push(skill);
    }
    this.setState({
      checkedSkills: checkedSkills
    });
  };

  async onSubmit(values, _, props) {
    let updatedSkills = [...this.state.checkedSkills]
    if (updatedSkills.length === 0) {
      this.setState({ isError: true });
    } else {
      props.dispatch(change('signup', 'skills', updatedSkills));
      const formattedValues = WithUserForm.formatUserSkillsInput({...values, skills: updatedSkills});
      await props.updateUserSkills({
        variables: { input: formattedValues },
      });
      return props.machine.service.send({
        type: "NEXT",
      });
    }
  }

  render() {
    return (
      <WithUserForm
        onSubmit={(values, _, props) => this.onSubmit(values, _, props, this)}
      >
        {({form: { handleSubmit }}) => {
          const footer = (
              <p className={`${styles.contact_us_link} ${styles.default_text_size}`} style={{ color: '#B08D57' }}>
                Having trouble? <a href="https://wa.me/447588663357" style={{ color: '#B08D57', textDecoration: 'underline', fontWeight: 'bold' }}>Contact us</a>.
              </p>
          );
          return (
            <Step footer={footer}>
              <p
                  className="text-white text-md"
                  style={{
                    fontWeight: 700,
                    fontSize: 'clamp(14px, 2.5vh, 18px)'
                  }}
              >What do you do?</p>
              <form onSubmit={handleSubmit} className={styles.form_step_skills}>
                <Field
                  name="skills"
                  component={SelectedSkills}
                  handleCheckedSkills={this.handleCheckedSkills}
                  checkedSkills={this.state.checkedSkills}
                  isFashionIconSelected={this.state.isFashionIconSelected}
                  isBrandSelected={this.state.isBrandSelected}
                  toggleCategory={this.toggleCategory}
                />
                <div
                    className="flex justify-center"
                    style={{
                      marginTop: "4vh",
                      width: "80%"
                    }}
                >
                  <button
                    className={`${stylesButton.button} ${styles.default_text_size} ${
                      stylesButton.button_submit
                    }`}
                    type="submit"
                    disabled={this.state.checkedSkills.length === 0 || (!this.state.isFashionIconSelected && !this.state.isBrandSelected)}
                  >
                    Next
                  </button>
                </div>
              </form>
            </Step>
          )
        }}
      </WithUserForm>
    );
  }
}
